import React, { useEffect, useState } from "react";
import { Modal, Button, Form, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CustomInput from "../../common/CustomInput";
import ImagesInput from "../../common/ImagesInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { CreateOccasion, UpdateOccasion } from "../../../redux/actions/productActions";
import { RESET_ERROR } from "../../../redux/constants/userConstants";

const AddOccasion = ({ openModal, onCloseModal, data, setActiveData, title }) => {
    const dispatch = useDispatch();
    const { newoccasion, error } = useSelector(state => state.product);
    const [images, setImage] = useState(null);
    const [loading, setLoading] = useState(false);

    const schema = yup.object({
        name: yup.string()
            .matches(/^[A-Za-z0-9\s]+$/, "Occasion name must contain only alphabets and numbers")
            .max(40, "Occasion name must be at most 40 characters")
            .required("Occasion name is required"),
        image: yup.mixed().when("localImage", {
            is: false,
            then: yup.mixed()
                .test("required", "Image resolution should be 256px * 256px", (file) => !!file)
                .test("fileSize", "The file is too large", (file) => file && file.size <= 2000000),
        }),
        localImage: yup.boolean(),
    });

    const { control, handleSubmit, formState: { errors }, reset, setValue, setError } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            name: '',
            image: null,
            localImage: false
        }
    });

    useEffect(() => {
        if (data) {
            setValue("name", data?.name);
            setValue("localImage", data?.image ? true : false);
        }
    }, [data]);

    useEffect(() => {
        if (newoccasion) {
            reset();
        }
    }, [newoccasion]);

    useEffect(() => {
        if (error) {
            dispatch({ type: RESET_ERROR });
        }
    }, [error]);

    const saveOccasion = (formValues) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('name', formValues.name);
        if (data?._id) {
            formData.append('id', data?._id);
            formData.append('status', data?.status);
        }
        if (formValues.image) {
            formData.append('image', formValues.image);
        }

        const action = data ? UpdateOccasion : CreateOccasion;
        dispatch(action(formData)).finally(() => setLoading(false));
    };

    const clearclose = () => {
        setActiveData(null);
        onCloseModal();
        reset();
    };

    const onImgLoad = ({ target: img }) => {
        if (img.offsetWidth === 256 && img.offsetHeight === 256) {
            setValue("image", images);
        } else {
            setImage(null);
            setValue("image", null);
            setError("image", {
                type: 'custom',
                message: "Image resolution should be 256px * 256px"
            });
        }
    };

    return (
        <Modal isOpen={openModal} toggle={clearclose} size="lg">
            <ModalHeader toggle={clearclose}>
                <h5 className="modal-title f-w-600" id="occasionModalLabel">
                    {title}
                </h5>
            </ModalHeader>
            <ModalBody>
                <Form>
                    <CustomInput
                        fieldLabel='Occasion Name :'
                        control={control}
                        error={errors.name}
                        fieldName='name'
                    />

                    {data?.image && <img src={data?.image} alt="occasion" style={{ width: 50, height: 50 }} />}

                    <ImagesInput
                        fieldLabel='Image : 256px * 256px'
                        control={control}
                        error={errors.image}
                        fieldName='image'
                        type='file'
                        onChangeValue={(file) => setImage(file)}
                    />
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    disabled={loading}
                    color="primary"
                    onClick={handleSubmit(saveOccasion)}
                >
                    {loading ? "Saving" : "Save"}
                </Button>
            </ModalFooter>
            {images && <div style={{ height: 1, opacity: 0 }} ><img onLoad={onImgLoad} src={URL.createObjectURL(images)} /></div>}
        </Modal>
    );
};

export default AddOccasion;

